import { A4uBoxExport as IconComponent } from '@adobe/react-spectrum-workflow/dist/BoxExport.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function BoxExport(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}